import axios from 'axios';

export default function getPerson(email, cognitoId, config) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const args = email ? `?email=${email}` : `?cognitoId=${cognitoId}`;
  const url = config.postPersons + args;
  return dispatch => dispatch({
    type: 'PERSON_FETCH',
    payload: axios({ method: 'get', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}


// WEBPACK FOOTER //
// ./src/actions/getPerson.js